<template>
  <form
    ref="form"
    data-url="/annexes"
    class="mb-0"
    :class="{ 'loading-opacity': preloader }"
    enctype="multipart/form-data"
  >
    <div class="row">
      <div class="col-md-12">
        <app-note
          class="mb-primary"
          :title="$t('note')"
          content-type="html"
          :notes="formRowInstruction"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <table id="annexes">
          <AnnexedFileReview
            v-for="(value, index) in inputs"
            :key="index"
            :inputs="value"
          />
        </table>
      </div>
    </div>

    <div class="row">
      <div class="col-12 mt-3">
        <!-- <button type="submit" class="btn btn-primary" @click.prevent="submit">
          {{ $t("save") }}
        </button> -->
      </div>
    </div>
  </form>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import * as actions from "../../apiUrl";
import AnnexedFile from "./AnnexedFile.vue";
export default {
  components: { AnnexedFile },
  name: "Annexes",
  mixins: [FormMixin],
  data() {
    return {
      preloader: false,
      inputs: [],

      formRowInstruction: [this.$t("annexes_info")],
    };
  },
  created() {
    this.data();
  },
  methods: {
    beforeSubmit() {
      this.preloader = true;
    },

    submit() {
      let formData = new FormData();
      for (let index = 0; index < this.inputs.length; index++) {
        formData.append("id[]", this.inputs[index].id);
        formData.append("is_charged[]", this.inputs[index].is_charged);
        formData.append(
          `file_${this.inputs[index].id}`,
          this.inputs[index].file
        );
      }
      this.save(formData);
    },

    afterSuccess(res) {
      this.$toastr.s(this.$t("updated_success"));
    },

    afterFinalResponse() {
      this.preloader = false;
    },

    afterError(res) {
      this.$toastr.e(res.data.message);
    },

    data() {
      this.preloader = true;
      this.axiosGet(
        `${actions.ANNEXES}/show?accreditation_application_id=${this.$store.state.accreditation.id}`
      )
        .then((response) => {
          if (response.status == 200) {
            this.inputs = response.data ? response.data : {};
          }
        })
        .catch((error) => {
          console.log("Annexes: " + error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },
  },
};
</script>
<style lang="css">
#annexes {
  width: 100%;
}
#annexes tr {
  border: 1px dotted gray;
}
#annexes td {
  padding: 0.8rem;
}
#annexes .letter {
  width: 5%;
  text-align: center;
}
#annexes .name {
  text-align: justify;
}
#annexes .attached-file {
  width: 10%;
  text-align: center;
}
</style>